import { Pipe, PipeTransform, inject } from '@angular/core';
import { FormattingOverrides } from '@zag/core/common';
import { FormattingService } from './formatting.service';

/**
 * Formats a decimal value (0–1) as a percent using the active locale.
 *
 * @param value - A decimal value between 0 and 1, e.g. 0.856 for 85.6%
 *
 * Usage:
 * ```html
 * {{ 0.856 | zagPercent }}                                        → "85.6%" (en)
 * {{ 0.5 | zagPercent : { minimumFractionDigits: 0, maximumFractionDigits: 0 } }} → "50%"
 * ```
 */
@Pipe({
  name: 'zagPercent',
  pure: false,
})
export class ZagPercentPipe implements PipeTransform {
  private readonly formattingService = inject(FormattingService);

  transform(
    value: number | null | undefined,
    overrides?: FormattingOverrides & { minimumFractionDigits?: number; maximumFractionDigits?: number }
  ): string {
    if (value == null) {
      return '';
    }
    return this.formattingService.formatPercent(value, overrides);
  }
}
